<template>
  <div class="nav">
    <a-card>
      <div class="head-left">カテゴリ</div>
      <div v-for="(nav, index) in navbars" :key="`left-menu-${index}`" class="nav-item">
        <a>{{nav.name}}</a>
        <span :class="'icon ' + nav.icon"></span>
      </div>
       <a-divider />
       <div class="head-left mt-4">過去のお知らせ</div>
      <div v-for="(nav, index) in navbars" :key="index" class="nav-item">
        <a>{{nav.date}}</a>
        <span :class="'icon ' + nav.icon"></span>
      </div>
    </a-card>
  </div>
</template>

<script>

export default {
  name: 'LeftMenuNoti',
  data() {
    return {
      navbars: [
        { path: '', date: '2020年', name: 'すべて' },
        { path: '', date: '2019年', name: '重要なお知らせ' },
        { path: '', date: '2018年', name: 'メンテナンス・障害情報' },
        { path: '', date: '2017年', name: 'サービスについて' },
        { path: '', date: '2016年', name: '提携メニューについて' },
        { path: '', date: '2015年', name: '法対応について' },
        { path: '', name: 'その他' }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import './style.scss';
</style>